export default class CollapseText {

    protected buttons;

    constructor() {
       // this.buttons = Array.from(document.querySelectorAll('.collapse-text__button'));

       /* if (!this.buttons.length)
            return;*/

        $(document).on('click', '.collapse-text__button', (event) => {
            this.toggle(event)
        })

      /*  this.buttons.forEach(item => {
            item.addEventListener('click', this.toggle.bind(this))
        })*/
    }

    toggle(event) {
        console.log(event)
        const button = event.currentTarget;
        const container = button.parentNode;
        const isOpened = container.classList.contains('_opened');

        if (isOpened) {
            button.innerHTML = 'Развернуть'
            container.classList.remove('_opened')
        } else {
            button.innerHTML = 'Свернуть'
            container.classList.add('_opened')
        }
    }
}
